import { get } from "@/services/http/platformServer";
import OrderDTO from "@/dto/order/OrderDTO";

export interface ScanPrintResult {
    shopId: number;
    orders: OrderDTO[];
}

export const getByWaybillNo = (shopIds: number[], waybillNo: number | string) => {
    const shopIdsStr = shopIds.join();
    return get<ScanPrintResult[]>(shopIds[0], "/scan_printing/get_by_waybill_no", { shopIds: shopIdsStr, waybillNo });
};

export function getByOriginalId(shopIds: number[], originalId: string) {
    const shopIdsStr = shopIds.join();
    return get<ScanPrintResult[]>(shopIds[0], "/scan_printing/get_by_original_id", { shopIds: shopIdsStr, originalId });
}
